module.exports = __webpack_public_path__ + "media/images/redox/RedoxInteractive_Logo-7e968b677c28493a1fb5709f900385cd.jpg";